import styled from '@emotion/styled';
import { isEmptyText, Prismic, PrismicText } from '@landsbankinn/prismic';
import { device, Segment } from '@landsbankinn/ui';
import React from 'react';
import { Intro } from '../components/intro/Intro';

interface IProps {
  title?: Prismic.RichText;
  copy: Prismic.RichText;
  splitter: boolean;
}

const Splitter = styled.div`
  text-align: center;
  position: relative;
  color: ${(props) => props.theme.colors.primary};

  &:before {
    content: '';
    width: 100%;
    position: absolute;
    top: 50%;
    margin-top: -1px;
    height: 1px;
    background: ${(props) => props.theme.colors.primary};
    left: 0;
    z-index: 1;
  }
  p {
    background: ${(props) => props.theme.colors.background};
    font-family: ${(props) => props.theme.font.familySerifCond};
    font-weight: 500;
    margin: 0 auto;
    position: relative;
    z-index: 2;

    display: inline-block;
    padding-left: 20px;
    padding-right: 20px;
  }
  @media ${device.tablet} {
    p {
      width: 220px;
      padding-left: 0;
      padding-right: 0;
    }
  }
`;

export const AnnualIntroContainer = ({ title, copy, splitter }: IProps) => {
  if (isEmptyText(copy)) {
    return null;
  }

  const hasTitle = title && !isEmptyText(title);

  return (
    <Segment isArticle className="intro" id="hero">
      <Intro
        title={hasTitle && Prismic.text(title ?? null)}
        hasSplitter={splitter}
      >
        {splitter ? (
          <Splitter>
            <PrismicText value={copy} />
          </Splitter>
        ) : (
          <PrismicText value={copy} />
        )}
      </Intro>
    </Segment>
  );
};
